export enum CrusadeHonourTypes {
   Other = 0,
   BattleHonour = 1,
   BattleScar = 2,
}
